<template>
  <table :class="getTableClasses" style="width:100%">
    <thead>
    <tr>
      <th>#</th>
      <th> Vessel Id</th>
      <th> Name</th>
      <th> Email</th>
      <th> image</th>
      <th> Vessel Type</th>
      <th> Vessel Model</th>
      <th> Build Year</th>
      <th> Status</th>
      <th v-if="!isPrinting"> Action</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(vessel , index) in listData" :key="vessel.id">
      <td>{{index+1}}</td>
      <td>{{vessel?.id}}</td>
      <td>{{vessel?.name}}</td>
      <td>{{vessel?.email}}</td>
      <td>
        <img v-if="vessel.image!=null " :src="vessel?.image" height="50" width="50"/>

      </td>
      <td>{{vessel?.vessel_type?.name}}</td>
      <td>{{vessel?.engine_model}}</td>
      <td>{{vessel?.build_year}}</td>
      <td>{{vessel?.status == 'Activate' ? 'Active' : 'Inactive'}}</td>
      <td v-if="!isPrinting">
        <button type="button" @click="show(vessel)" class="btn btn-info btn-sm">
          <i class="fa fa-eye"></i>
        </button>
        <button v-if="isPermissionExist(PERMISSIONS.VESSEL_EDIT)" type="button" @click="edit(vessel)" class="btn btn-primary btn-sm">
          <i class="fa fa-edit"></i>
        </button>
        <button
          v-if="isPermissionExist(PERMISSIONS.VESSEL_DELETE)"
          type="button"
          @click="destroy(vessel)"
          class="btn btn-danger btn-sm"
        >
          <i class="fa fa-trash"></i>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>

import PermissionsMixin from "@/mixin/permissionsMixin";
import auth from "@/auth";

export default {
  mixins: [PermissionsMixin],
  props: {
    listData : {
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 20
    },
    isPrinting: {
      type: Boolean,
      default: false
    },
    show: {
      type: Function,
      required: false
    },
    edit: {
      type: Function,
      required: false
    },
    destroy: {
      type: Function,
      required: false
    },
  },
  data() {
    return {
      permissions: auth.getPermissionData(),
    }
  },

   computed: {
    getTableClasses() {
      return {
        'table': true,
        'text-center': true,
        'table-striped': !this.isPrinting,
        'table-bordered': !this.isPrinting,
        'table-sm': !this.isPrinting,
        'print-table': this.isPrinting,
      };
    }
  }
};
</script>

<style scoped>

</style>
